module.exports = __webpack_public_path__ + "static/media/submitAssessmentImg.35ac06ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/submitAssessmentImg.png
// module id = 181
// module chunks = 0